import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import DeliveryForm from "./Deliveryform";

const DeliveryModeSection = ({
  deliveryModes,
  selectedDeliveryMode,
  handleSelectDeliveryMode,
  showDeliveryModeForm,
  setShowDeliveryModeForm,
  isAddressSelected,
  deliveryScheduleDate,
  setDeliveryScheduleDate,
  pickupStation,
  setPickupStation,
  selectedAddress,
  isDeliveryModeSelected,
  setIsDeliveryModeSelected,
  clearDeliveryMode,
  handleConfirmDeliveryMode,
  counties
}) => {
  const [scheduledDate, setScheduledDate] = useState(null);

  // Calculate delivery date when component mounts or selectedDeliveryMode changes
  useEffect(() => {
    if (selectedDeliveryMode && !deliveryScheduleDate) {
      const currentDate = new Date();
      const deliveryDays = 5;
      const scheduledDelivery = new Date(currentDate);
      scheduledDelivery.setDate(currentDate.getDate() + deliveryDays);
      setScheduledDate(scheduledDelivery);
      setDeliveryScheduleDate(scheduledDelivery);
    }
  }, [selectedDeliveryMode, deliveryScheduleDate, setDeliveryScheduleDate]);

  return (
    <div className={`p-6 bg-white rounded-lg shadow-md mb-6 animate-fade-in transition-all duration-300 ${!isAddressSelected ? "opacity-50 pointer-events-none" : ""}`}>
      <h2 className="text-xl font-bold text-gray-800 mb-4">2. Delivery Mode</h2>

      <div className="space-y-4">
        {deliveryModes.map((mode) => (
          <div 
            key={mode.id} 
            className={`flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
              selectedDeliveryMode === mode.id 
                ? "border-orange-500 bg-gradient-to-r from-orange-50 to-yellow-50 shadow-md transform scale-[1.02]" 
                : "border-gray-200 hover:border-orange-300 hover:shadow-sm"
            }`}
            onClick={() => handleSelectDeliveryMode(mode.id)}
          >
            <input
              type="radio"
              name="deliveryMode"
              checked={selectedDeliveryMode === mode.id}
              onChange={() => {}}
              className="h-5 w-5 text-orange-500 focus:ring-orange-400"
            />
            <div className="ml-3 flex-shrink-0">
              <img src={mode.logo} alt={mode.name} className="h-10 w-10 object-contain" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-900">{mode.name}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedDeliveryMode === 1 && showDeliveryModeForm && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
    {/* Modal Container */}
    <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-1/2 lg:w-1/3 shadow-lg rounded-md bg-white">
      {/* Close Button */}
      <button
        onClick={() => setShowDeliveryModeForm(false)}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-red-100 transition-colors"
        aria-label="Close modal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      
      <DeliveryForm 
        onPickupStationSelected={(station) => setPickupStation(station)}
        onConfirmDeliveryMode={handleConfirmDeliveryMode}
        onDeliveryModeSelection={setShowDeliveryModeForm}
        setIsDeliveryModeSelected={setIsDeliveryModeSelected}
        counties={counties}
      />
    </div>
  </div>
)}

      {selectedDeliveryMode === 2 && (
        <div className="mt-4 p-5 bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 rounded-lg shadow-sm">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </div>
            <div className="ml-3 flex-1">
              <h3 className="text-lg font-semibold text-blue-900 mb-2">Home Delivery</h3>
              {selectedAddress && (
                <div className="space-y-1 text-sm text-blue-800">
                  <p className="font-medium">Delivery Address:</p>
                  <p>{selectedAddress.name}</p>
                  <p>{selectedAddress.county}, {selectedAddress.town}</p>
                  {selectedAddress.extraInformation && (
                    <p className="text-blue-700">{selectedAddress.extraInformation}</p>
                  )}
                  <p className="text-blue-700">Phone: {selectedAddress.phoneNumber}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {isDeliveryModeSelected && selectedDeliveryMode && (
        <div className="mt-6 p-4 bg-gradient-to-r from-gray-50 to-slate-50 rounded-lg border-2 border-gray-200 shadow-sm animate-scale-in">
          <div className="mb-3">
            <p className="text-sm font-medium text-gray-700 flex items-center gap-2">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Delivery Scheduled on {scheduledDate?.toDateString()}
            </p>
          </div>

          <div className="p-4 bg-white border border-orange-200 rounded-md shadow-sm mb-3">
            <p className="text-sm text-gray-800 flex items-start gap-2">
              <svg className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>
                {selectedDeliveryMode === 1 ? (
                  `Pick up your order from ${pickupStation}`
                ) : (
                  `Your Order will be delivered to:
                ${selectedAddress.name}, ${selectedAddress.county}, ${selectedAddress.town}, ${selectedAddress.extraInformation}`
                )}
              </span>
            </p>
          </div>

          <button
            onClick={clearDeliveryMode}
            className="text-sm text-orange-600 hover:text-orange-800 font-medium transition-all duration-200 hover:underline flex items-center gap-1"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            Clear Delivery Mode Selection
          </button>
        </div>
      )}
    </div>
  );
};

export default DeliveryModeSection;